
export default {
  name: 'icon-status-delayed',
};
